import axios from 'axios';
import coreApi from './coreApi';
import type { Chat, MessageData } from '../../features/chat/types';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001/api';

// Create a separate instance for public routes that don't require authentication
const publicApi = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    }
});

export const chatApi = {
    async getChats() {
        const response = await coreApi.get('/chats');
        return response.data.chats;
    },

    async getChat(chatId: string) {
        const response = await coreApi.get(`/chats/${chatId}`);
        return response.data.chat;
    },

    async createChat(content: string, userId: string) {
        const response = await coreApi.post('/chats', { content, userId });
        return response.data.chat;
    },

    async deleteChat(chatId: string) {
        const response = await coreApi.delete(`/chats/${chatId}`);
        return response.data.success;
    },

    async getMessages(chatId: string) {
        const response = await coreApi.get(`/chats/${chatId}/messages`);
        return response.data.messages;
    },

    async createMessage(chatId: string, message: Partial<MessageData>) {
        const response = await coreApi.post(`/chats/${chatId}/messages`, message);
        return response.data.message;
    },

    async getSharedChat(publicId: string) {
        const response = await publicApi.get(`/chats/shared/${publicId}`);
        return response.data.chat;
    },

    async updateChatSharing(chatId: string, isPublic: boolean, publicId: string | null) {
        const response = await coreApi.put(`/chats/${chatId}/sharing`, { isPublic, publicId });
        return response.data.success;
    },

    async getSharedChatWithMessages(publicId: string) {
        const response = await publicApi.get(`/chats/shared/${publicId}/messages`);
        return response.data;
    },

    async generateFollowUpQuestions(chatId: string, content: string) {
        const response = await coreApi.post(`/chats/${chatId}/questions`, { content });
        return response.data.questions;
    },

    async deleteAllChats() {
        const response = await coreApi.delete(`/chats/all`);
        return response.data.success;
    },

    async reportChat(chatId: string, { reason }: { reason: string }) {
        const response = await coreApi.post(`/chats/${chatId}/report`, { reason });
        return response.data;
    }
};